// Module
var code = "<workbench-requirements-form modal-instance=\"vm.$uibModalInstance\" loan-id=\"vm.loanId\" requirement=\"vm.requirement\" clients=\"vm.clientsList\"></workbench-requirements-form> ";
// Exports
module.exports = code;